import { Empty } from 'antd'
import React from 'react'

export const EmptyPersonalizado = () => {
  return (
    <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="No hay datos para mostrar"
    />
  )
}
